export const COMMUNITY_LINKS = {
  HOMEPAGE: 'https://zkex.com',
  TWITTER: 'https://twitter.com/ZKEX_Official',
  MEDIUM: 'https://zkex.medium.com',
  DISCORD: 'https://discord.gg/ctDAYrrNTH',
  TELEGRAM: 'https://t.me/ZKEX_Official',
  USER_DOCS: 'https://docs.zkex.com',
  NEWSLETTER: 'https://zkex.substack.com',
  BUG_REPORT:
    'https://docs.google.com/forms/d/e/1FAIpQLSfK7riyroZjJlEr0pHizDGT354tEeSD-FPUmtrKXHowMtHp_w/viewform',
  DOCS_TRADING_FEES: 'https://docs.zkex.com/overview/fees#trading-fees',
  CAREERS:
    'https://wellfound.com/jobs/2487796-marketing-social-media?utm_campaign=startup_share&utm_content=startup_share_module&utm_medium=social&utm_term=zkex',
} as const
